/* eslint-disable react/forbid-prop-types,import/prefer-default-export,import/no-unresolved */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isBrowser, isIOS } from 'react-device-detect';
import Input from '../../../../components/Input';
import { getMaskedPhoneNumber } from '../../../../utilities/helpers';

export const TFASecurityComponent = ({
  form,
  handleSubmit,
  handleResendOnClick,
  handleChange,
  timer,
  isLoading,
  state,
  isTOTP,
}) => {
  const { t: translate } = useTranslation();

  return (
    <>
      <form onSubmit={handleSubmit} id="confirm-phone-form">
        {!isTOTP && (
          <Input
            subLabel={`${translate('confirm_phone_number_message_label_nosec').replace(
              '%s',
              getMaskedPhoneNumber(form?.confirmed_phone_number, state?.country_code)
            )} ${timer} ${translate('email_verification_subtext_label_sec')}`}
            value={form.code}
            name="code"
            type="number"
            onChange={handleChange}
            actionLabel={translate('resend_button_label')}
            actionClick={handleResendOnClick}
            actionDisabled={isLoading || timer > 0}
            placeholder={translate('confirm_phone_number_code_label')}
            label={translate('confirm_phone_number_code_label')}
            errorLabel={translate('verification_code_error_label')}
            groupClassName={`mb-0 pb-0 mt-4 ${isIOS ? 'ios' : ''}`}
            className={`${isIOS ? 'ios' : ''}`}
            withFloatingLabel
            withSubLabel
            withErrorLabel
            autoComplete="off"
            actionBtnTop="18%"
          />
        )}
        {isTOTP && (
          <Input
            groupClassName={`mb-0 ${isBrowser ? 'mt-4 pt-3' : 'mt-4'}`}
            value={form.code}
            name="code"
            type="number"
            onChange={handleChange}
            placeholder={translate('whitelist_verify_code_totp')}
            label={translate('whitelist_verify_code_totp')}
            errorLabel={translate('verification_code_error_label')}
            autoComplete="off"
            actionBtnTop="18%"
            withFloatingLabel
            withErrorLabel
            required
          />
        )}
      </form>
    </>
  );
};

TFASecurityComponent.propTypes = {
  form: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleResendOnClick: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  timer: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  state: PropTypes.object.isRequired,
  isTOTP: PropTypes.bool.isRequired,
};
